import { gql } from "@apollo/client";

export const GET_REFERRAL = gql`
  query RewardsUserBalance {
    showIndicationInfo {
      id
      code
      title
      description
      external_key
      owner
      rule_id
      url
      created_at
      updated_at
      invitationData {
        invitationsAccepted
        invitationsFinalized
      }
    }
    rewardsUserBalance {
      totalBlackcoins
    }
    rewardsProductsStore {
      _id
      type
      name
      description
      imageUrl
      blackcoins
      deliveryTime
      brand
      value
    }
    rewardsUserTransactionsHistory {
      totalBlackcoins
      transactions {
        _id
        title
        description
        type
        value
        status
        date
        note
        image
        metadata {
          product {
            brand
            value
            type
          }
        }
      }
    }
  }
`;